import enGB from './en-GB/translate.json';
import enUK from './en-UK/translate.json';
import frFR from './fr-FR/translate.json';
import ptBR from './pt-BR/translate.json';
import deDE from './de-DE/translate.json';
import srRS from './sr-RS/translate.json';
import csCZ from './cs-CZ/translate.json';
import enAU from './en-AU/translate.json';
import arAR from './ar-AR/translate.json';
import esES from './es-ES/translate.json';
import esAR from './es-AR/translate.json';
import esCO from './es-CO/translate.json';
import hrHR from './hr-HR/translate.json';
import frCH from './fr-CH/translate.json';
import thTH from './th-TH/translate.json';
import itIT from './it-IT/translate.json';

const langs = {
  en_GB: enGB,
  en_US: enGB,
  en_UK: enUK,
  en_CA: enGB,
  en_IN: enGB,
  en_AU: enAU,
  ar_AR: arAR,
  ar_IL: arAR,
  ar_BH: arAR,
  ar_DZ: arAR,
  ar_KW: arAR,
  ar_AE: arAR,
  es_ES: esES,
  es_CO: esCO,
  es_AR: esAR,
  es_CL: esCO,
  fr_FR: frFR,
  fr_CH: frCH,
  pt_BR: ptBR,
  de_DE: deDE,
  cs_CZ: csCZ,
  hr_HR: hrHR,
  th_TH: thTH,
  it_IT: itIT,
  sr: srRS,
};

export default langs;
